import React from "react";
import { useSalon } from "../../context/SalonContext";
import ReviewsCard from "./ReviewsCard";
import AllReviewsModal from "./AllReviewsModal";
import { useState } from "react";
import "./Reviews.css";

export default function SalonReviews() {
    const { salonUuid, salonName } = useSalon();
    const [showAll, setShowAll] = useState(false);

    if (!salonUuid) {
        return (
            <div className="view-bookings-page">
                <header className="loyalty-header-hero">
                    <div className="content-wrapper">
                        <h1 className="header-title">Salon Reviews</h1>
                        <div className="mobile-accent-diamond">♦</div>
                    </div>
                </header>
                <div className="appointments-content-container py-4 text-center">
                    <p>Please select a salon first to view reviews.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="view-bookings-page">
            <header className="loyalty-header-hero">
                <div className="content-wrapper">
                    <h1 className="header-title">Salon Reviews</h1>
                    <div className="mobile-accent-diamond">♦</div>
                    {salonName && <p className="salon-subtitle">{salonName}</p>}
                </div>
            </header>

            <div className="appointments-content-container py-4">
                <ReviewsCard
                    salonUuid={salonUuid}
                    onOpenAll={() => setShowAll(true)}
                />

                <AllReviewsModal
                    visible={showAll}
                    onClose={() => setShowAll(false)}
                    salonUuid={salonUuid}
                />
            </div>
        </div>
    );
}
